import { useGetProfileQuery } from '../api'
import type { TUser } from '../api/types'
import { isProfileComplete } from '../utils/profile/isProfileComplete'

export type ProfileGateStatus = 'guest' | 'loading' | 'error' | 'ready'

export type UseProfileGateResult = {
  status: ProfileGateStatus
  user?: TUser
  isProfileReady: boolean
  isProfileComplete: boolean
  isProfileLoading: boolean
  isProfileError: boolean
}

export const useProfileGate = (): UseProfileGateResult => {
  const query = useGetProfileQuery()

  const isLoading = query.isUninitialized || query.isLoading || (query.isFetching && !query.data)
  if (isLoading) {
    return {
      status: 'loading',
      user: query.data,
      isProfileReady: false,
      isProfileComplete: false,
      isProfileLoading: true,
      isProfileError: false,
    }
  }

  if (query.isError || !query.data) {
    const status = (query.error as any)?.status
    if (status === 401) {
      return {
        status: 'guest',
        user: undefined,
        isProfileReady: true,
        isProfileComplete: false,
        isProfileLoading: false,
        isProfileError: false,
      }
    }
    return {
      status: 'error',
      user: undefined,
      isProfileReady: false,
      isProfileComplete: false,
      isProfileLoading: false,
      isProfileError: true,
    }
  }

  return {
    status: 'ready',
    user: query.data,
    isProfileReady: true,
    isProfileComplete: isProfileComplete(query.data),
    isProfileLoading: false,
    isProfileError: false,
  }
}
